import {Injectable} from '@angular/core';
import {ModifyMenuDataAddon} from '../../../types/product.type';
import {addonStore} from './addon.store';
import {setProps} from '@ngneat/elf';

@Injectable({providedIn: 'root'})
export class AddonManager {
  public setModifyMenuData(modifyMenuDataAddon: ModifyMenuDataAddon) {
    addonStore.update(setProps({modifyMenuData: modifyMenuDataAddon}));
  }

  public setUpdatedModifyMenuData(modifyMenuDataAddon: ModifyMenuDataAddon) {
    addonStore.update(setProps({modifyMenuDataUpdated: modifyMenuDataAddon}));
  }

  public reset() {
    addonStore.reset();
  }
}
